import React from 'react';
import env from 'env';
import { useState, useEffect } from 'react';
import { Table } from 'components/table/table';
import { SiteLink } from 'components';

export function MemberList(props){
    const [result, setResult] = useState();
    //const [pageLoading, setPageLoading] = useState(false);

    const columns = React.useMemo(
        () => [
          {
            Header: 'Name',
            accessor: 'name',
            Cell: (c) => {
                return (<SiteLink to={`/admin/member/edit/${c.row.original.userId}`}><b>{c.cell.value}</b></SiteLink>)
            }
          },
          {
            Header: 'Organisation',
            accessor: 'organisation',
            Cell: (c) => {
                return c.cell.value && c.cell.value !== "" ? c.cell.value : "-";
            }
          },
          {
            Header: 'Email',
            accessor: 'email'
          },
          {
            Header: 'Status',
            accessor: (c) => {
                var value;
                switch(c.profileStatus){
                    case 0 :
                        value = "Active";
                        break;
                    case 99 : 
                        value = "Inactive";
                        break;
                    default :
                        value = "";
                }
                return value;
            }
          }
        //   {
        //     Header: 'Address',
        //     accessor: 'address'
        //   }
        ],
        []
    )

    useEffect(()=>{
        const fetchData = async () => {
            const res = await fetch(env.apiBase + "/api/profile/getmemberlist");
            const data = await res.json();
            console.log("James Member List", data);
            setResult({
                memberList : data.results.memberList
            });
        };
        fetchData();
    }, []);
    
    return(
        result ? <>
            {
                (result.memberList && result.memberList.length > 0) ?
                <Table columns={columns} data={result.memberList} /> :
                <div>There is no</div>
            }
        </> :
        <div></div>
    )
}